import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateEndorsementFormData } from 'src/features/rfqDataSlice';

const SuggestedDeductible = ({ policyDetails }) => {
  const dispatch = useDispatch();

  const [isEditable, setIsEditable] = useState(false);

  const [suggestedDeductibleData, setsuggestedDeductibleData] = useState({
    suggestedDeductible: false,
    suggestedDeductibleValue: policyDetails?.suggestedDeductible,
  });

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;

    const valueFromPolicy =
      policyDetails?.suggestedDeductible || '';

    setIsEditable(checked);

    setsuggestedDeductibleData({
      suggestedDeductible: checked,
      suggestedDeductibleValue:valueFromPolicy,
    });
  };

  useEffect(() => {
    dispatch(
      updateEndorsementFormData({
        suggestedDeductible:{
            isSelected:suggestedDeductibleData?.suggestedDeductible,
            oldValue:suggestedDeductibleData?.suggestedDeductible?policyDetails?.suggestedDeductible:'',
            newValue:''
        }  
      })
    );
  }, [suggestedDeductibleData, dispatch]);

  return (
    <>
      {policyDetails?.suggestedDeductible && (
        <>
          <Box sx={{ mb: 1, display: 'flex', gap: 1 }}>
            <Typography
              variant="h5"
              className="heading"
              sx={{
                background: 'rgb(9 84 174)',
                color: '#fff',
                py: 1,
                fontWeight: 'bold',
                width: '100%',
                pl: 2,
              }}
            >
             Deductible
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ pl: 2 }}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={suggestedDeductibleData.suggestedDeductible}
                    onChange={handleCheckboxChange}
                  />
                }
                label={policyDetails?.suggestedDeductible}
              />
            </Grid>

            
          </Grid>
        </>
      )}
    </>
  );
};

export default SuggestedDeductible;
